const TagManagerPlugin = {
  install (Vue, options) {
    let tagManager = {
      appendTags: null,
      tagList: [
        {
          desc: 'Pingdom Visitor Insights',
          src: '//rum-static.pingdom.net/pa-5bff7efacea07b0016000595.js',
          isLoaded: null
        }
      ]
    }
    tagManager.appendTags = function () {
      tagManager.tagList.map(tagInfo => {
        if (tagInfo.isLoaded === null) {
          let script = document.createElement('script')
          script.src = tagInfo.src
          tagInfo.isLoaded = false
          script.onload = function () {
            tagInfo.isLoaded = true
            console.log('Loaded tag: ' + tagInfo.desc)
          }
          script.onerror = function () {
            tagInfo.isLoaded = false
            console.error('Error loading: ' + tagInfo.src)
          }
          document.body.appendChild(script)
        }
      })
    }
    Vue.prototype.$tagManager = tagManager
    Vue.tagManager = tagManager
  }
}

export default TagManagerPlugin



// WEBPACK FOOTER //
// ./src/plugins/tagManager.js